import { useEffect, useRef } from "react";
import useApp from "../context/AppContext";
import { Item } from "../types";
import Decimal from "decimal.js";

type TabelaItensProps = {
  itens: Array<Item> | undefined;
};

const TabelaItens = (props: TabelaItensProps) => {
  const { itensPedido, setItens } = useApp();
  const textArea = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (props.itens) {
      props.itens.map(item => {
        if (!item.quantidadeMaxima)
          item.quantidadeMaxima = item.quantidade
      })
      setItens(props.itens);
    }
  }, [itensPedido, props.itens]);
  const handleValor = (newItens: Item[]) => {
    setItens(newItens)
  }
  const tot = props.itens?.reduce((partialSum, a) => partialSum + (a.checked ? (a.valorTotal ? a.valorTotal : 0) : 0), 0);
  const desc = props.itens?.reduce((partialSum, a) => partialSum + (a.checked ? a.desconto : 0), 0)
  if (!props.itens) return <h2>Nenhum item encontrado</h2>;
  else
    return (
      <div className="wrap-table100">
        <div className="table100 ver1 m-b-20">
          <table data-vertable="ver1" className="table table-hover table-itens">
            <thead>
              <tr className="row100 head">
                <th className="column100 w-auto px-2">Marcar</th>
                <th className="column100 column2">Pedido</th>
                <th className="column100 column2">Código URBAM</th>
                <th className="column100 column2">Código Fornecedor</th>
                <th className="column100 max-col">Descrição do Serviço</th>
                <th className="column100 col-qtde">Qtd</th>
                <th className="column100 column5">Un</th>
                <th className="column100 column7">Preço Unitário</th>
                <th className="column100 col-qtde">Desconto <br />R$</th>
                <th className="column100 column7">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              {itensPedido?.map((item, i) => {
                item.desconto = item.desconto ? item.desconto : 0;
                return (
                  <tr className={`row100 row100-lista-nf ${item.checked ? "table-primary" : ""}`} key={i}>
                    <td className="column100 column1">
                      <div className="form-check form-check-inline check-item-div">
                        <input
                          className="chekcitens"
                          type="checkbox"
                          checked={item.checked}
                          onChange={(e) => {
                            item.checked = e.currentTarget.checked
                            if (itensPedido) handleValor([...itensPedido])
                          }}
                        />
                      </div>
                    </td>
                    <td className="column100 column2" data-label="Pedido: ">
                      {item.idPedido}
                    </td>
                    <td className="column100 column2" data-label="Código URBAM: ">
                      {item.codigoUrbam}
                    </td>
                    <td className="column100 column9-insere" data-label="Código Fornecedor: ">
                      <div className="col-75">
                        <input
                          type="text"
                          className="form-control borda-cinza"
                          id="inputAddress"
                          placeholder=""
                          defaultValue={item.codigoFornecedor}
                          onChange={(e) => (item.codigoFornecedor = e.currentTarget.value)}
                        />
                      </div>
                    </td>
                    <td className="column100 column3-insere" data-label="Descrição do Serviço: ">
                      <div className="col-75">
                        <textarea
                          className="textarea-desc"
                          ref={textArea}
                          defaultValue={item.descricao}
                          onChange={(e) => (item.descricao = e.currentTarget.value)}
                        />
                      </div>
                    </td>
                    <td className="column100 col-qtde" data-label="Qtd: ">
                      <input
                        autoComplete="off"
                        type="text"
                        className="form-control borda-cinza"
                        placeholder=""
                        style={{ minWidth: "85px", textAlign: "center" }}
                        defaultValue={String(item.quantidade ?? "")}
                        onChange={(e) => {
                          let texto = e.currentTarget.value.replace(",", ".");
                          item.quantidade = texto;
                          const decimalQuantidade = new Decimal(texto || "0");
                          const decimalUnitario = new Decimal(item.valorUnitario || 0);
                          const decimalDesconto = new Decimal(item.desconto || 0);
                          const total = decimalQuantidade.mul(decimalUnitario).minus(decimalDesconto);
                          item.valorTotal = Number(total.toString());
                          if (itensPedido) handleValor([...itensPedido]);
                        }}
                      />
                    </td>
                    <td className="column100 column6" data-label="Un: ">
                      {item.unidade}
                    </td>
                    <td className="column100 column6" data-label="Preço Unitário: ">
                      {item.valorUnitario.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </td>
                    <td className="column100 col-qtde">
                      <input
                        autoComplete="off"
                        type="number"
                        step="0.00000000000001"
                        className="form-control borda-cinza"
                        id="inputAddress"
                        placeholder="0"
                        style={{ minWidth: "85px", textAlign: "center" }}
                        defaultValue={item.desconto ? item.desconto : 0}
                        onChange={(e) => {
                          item.desconto = parseFloat(e.currentTarget.value.replace(",", "."));
                          item.desconto = item.desconto ? item.desconto : 0;
                          //item.valorTotal = item.quantidade * item.valorUnitario - item.desconto;      
                          if (itensPedido) handleValor([...itensPedido])
                        }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) e.preventDefault();
                        }}
                        max={item.quantidade * item.valorUnitario}
                      />
                    </td>
                    <td className="column100 column7" data-label="Valor Total: ">
                      {props.itens && props.itens[i].valorTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <table className="table table-bordered rounded-bottom novo">

            <tfoot className="gradient rounded-bottom novo">
              <tr className="footer-tr novo">
                <td colSpan={7} />
                <td className="footer-itens" align="right"><strong> Total Bruto: {tot?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong> </td>
                <td className="footer-itens" align="right"><strong> Total Desconto: {desc?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong></td>
                <td className="footer-itens" align="right"><strong> Total : {((tot ? tot - (desc ? desc : 0) : 0))?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
};
export default TabelaItens;
